import { render, staticRenderFns } from "./system-update-icon.vue?vue&type=template&id=5c105643"
import script from "./system-update-icon.vue?vue&type=script&lang=js"
export * from "./system-update-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports